import { useCallback, useMemo, useState } from 'react';

import { daysAgo, now } from '@/lib/date';

import type { DashboardFilters, QuickFilter, RangeFilter } from '@/types/dashboard.type';

const RANGE_DAYS: Record<RangeFilter, number> = {
  '7': 7,
  '30': 30,
};

/**
 * Headless hook for managing dashboard filter state and
 * computing the date range used by the dashboard query.
 */
export function useDashboardFilters(defaultRange: RangeFilter = '7') {
  const [range, setRange] = useState<RangeFilter>(defaultRange);
  const [quick, setQuick] = useState<QuickFilter>('week');
  const [agentId, setAgentId] = useState<number | null>(null);

  const filters = useMemo<DashboardFilters>(
    () => ({
      from_date: daysAgo(RANGE_DAYS[range]),
      to_date: now(),
      agent_id: agentId,
    }),
    [range, agentId]
  );

  const onRangeChange = useCallback((value: RangeFilter) => {
    setRange(value);
  }, []);

  const onQuickChange = useCallback((value: QuickFilter) => {
    setQuick(value);
  }, []);

  const onAgentChange = useCallback((value: number | null) => {
    setAgentId(value);
  }, []);

  return {
    range,
    quick,
    agentId,
    filters,
    onRangeChange,
    onQuickChange,
    onAgentChange,
  } as const;
}
